import { Project, STORE_NEWS_LIST_SIZE, ContentType } from 'common/constants'

export enum DesignerStoreTab {
  'NEW' = 'NEW',
  'BRAND' = 'BRAND',
  'PRODUCT' = 'PRODUCT',
  'COLLECTION' = 'COLLECTION',
  'LOOKBOOK' = 'LOOKBOOK',
  'SHOWROOM' = 'SHOWROOM',
  'INTERVIEW' = 'INTERVIEW',
  'SUPPORTERS' = 'SUPPORTERS',
  'DIARY' = 'DIARY',
}

export const DesignerStoreContentTabs = [
  DesignerStoreTab.COLLECTION,
  DesignerStoreTab.LOOKBOOK,
  DesignerStoreTab.SHOWROOM,
  DesignerStoreTab.INTERVIEW,
  DesignerStoreTab.SUPPORTERS,
  DesignerStoreTab.DIARY,
]

type DesignerStoreTabConfig = {
  [key in DesignerStoreTab]?: {
    title: string
    path: string
    className: string
    contentType?: ContentType
    pageSize?: { [key in Project]?: number }
    showPageNumber?: { [key in Project]?: boolean }
    showKeyContent?: { [key in Project]?: boolean }
  }
}

export const DesignerStoreContentPath = {
  '/collection': DesignerStoreTab.COLLECTION,
  '/lookbook': DesignerStoreTab.LOOKBOOK,
  '/showroom': DesignerStoreTab.SHOWROOM,
  '/interview': DesignerStoreTab.INTERVIEW,
  '/supporters': DesignerStoreTab.SUPPORTERS,
  '/diary': DesignerStoreTab.DIARY,
}

const DesignerStoreTabConfig: DesignerStoreTabConfig = {
  NEW: {
    title: 'NEW',
    path: '/new',
    className: 'new',
    pageSize: {
      pc: 12,
      mobile: 5,
    },
  },
  BRAND: {
    title: 'BRAND',
    path: '/brand',
    className: 'brand',
  },
  PRODUCT: {
    title: 'PRODUCT',
    path: '/product',
    className: 'product',
    pageSize: {
      pc: 20,
      mobile: 10,
    },
  },
  COLLECTION: {
    title: 'COLLECTION',
    path: '/collection',
    className: 'collection',
    contentType: ContentType.COLLECTION,
    pageSize: {
      pc: 4,
      mobile: 5,
    },
    showPageNumber: {
      pc: true,
      mobile: false,
    },
    showKeyContent: {
      pc: true,
      mobile: false,
    },
  },
  LOOKBOOK: {
    title: 'LOOKBOOK',
    path: '/lookbook',
    className: 'lookbook',
    contentType: ContentType.LOOKBOOK,
    pageSize: {
      pc: 6,
      mobile: 5,
    },
    showPageNumber: {
      pc: true,
      mobile: false,
    },
    showKeyContent: {
      pc: true,
      mobile: false,
    },
  },
  SHOWROOM: {
    title: 'SHOWROOM',
    path: '/showroom',
    className: 'showroom',
    contentType: ContentType.SHOWROOM,
    pageSize: {
      pc: 3,
      mobile: 5,
    },
    showPageNumber: {
      pc: true,
      mobile: false,
    },
    showKeyContent: {
      pc: true,
      mobile: false,
    },
  },
  INTERVIEW: {
    title: 'INTERVIEW',
    path: '/interview',
    className: 'interview',
    contentType: ContentType.INTERVIEW,
    pageSize: {
      pc: 3,
      mobile: 5,
    },
    showPageNumber: {
      pc: true,
      mobile: false,
    },
    showKeyContent: {
      pc: true,
      mobile: false,
    },
  },
  SUPPORTERS: {
    title: 'SUPPORTERS',
    path: '/supporters',
    className: 'supporters',
    contentType: ContentType.SUPPORTERS,
    pageSize: {
      pc: 12,
      mobile: 5,
    },
  },
  DIARY: {
    title: 'DIARY',
    path: '/diary',
    className: 'diary',
    contentType: ContentType.DIARY,
    pageSize: {
      pc: 12,
      mobile: 5,
    },
  },
}

export const getDesignerStoreTitle = (id: DesignerStoreTab) => {
  return DesignerStoreTabConfig[id] && DesignerStoreTabConfig[id].title
}

export const getDesignerStorePath = (id: DesignerStoreTab) => {
  return DesignerStoreTabConfig[id] && DesignerStoreTabConfig[id].path
}

export const getDesignerStoreClassName = (id: DesignerStoreTab) => {
  return DesignerStoreTabConfig[id] && DesignerStoreTabConfig[id].className
}

export const getDesignerStoreContentType = (id: DesignerStoreTab) => {
  return (DesignerStoreTabConfig[id] && DesignerStoreTabConfig[id].contentType) || null
}

export const getDesignerStorePageSize = (id: DesignerStoreTab) => {
  return (
    DesignerStoreTabConfig[id] &&
    DesignerStoreTabConfig[id].pageSize &&
    DesignerStoreTabConfig[id].pageSize[process.env.PROJECT_NAME]
  )
}

export const showDesignerStoreKeyContent = (id: DesignerStoreTab) => {
  return (
    DesignerStoreTabConfig[id] &&
    DesignerStoreTabConfig[id].showKeyContent &&
    DesignerStoreTabConfig[id].showKeyContent[process.env.PROJECT_NAME]
  )
}

export const showDesignerStorePageNumber = (id: DesignerStoreTab) => {
  return (
    DesignerStoreTabConfig[id] &&
    DesignerStoreTabConfig[id].showPageNumber &&
    DesignerStoreTabConfig[id].showPageNumber[process.env.PROJECT_NAME]
  )
}

export const DesignerCategory = {
  '10022': {
    displayCategoryId: '11009002',
    displayCategoryName: '루키',
  },
  '10023': {
    displayCategoryId: '11009001',
    displayCategoryName: '스타',
  },
}

export enum DesignerCategoryType {
  LOOKIE = '10022',
  STAR = '10023',
}
